import React from 'react';
import FieldView from "../../../../components/FieldView";
import {formDefFazendaCorte} from "../forms";
import {QuestionarioFazendaObject} from "../../../../models/Questionario";

interface QuestionarioCorteV1Props {
  questionario: QuestionarioFazendaObject
}

const QuestionarioCorteV1: React.FC<QuestionarioCorteV1Props> = ({questionario}) => {
  return (
    <>
      <FieldView value={questionario.femeas_idade_reprodutiva}
                 def={formDefFazendaCorte.femeas_idade_reprodutiva}/>
      <FieldView value={questionario.touros} def={formDefFazendaCorte.touros}/>
      <FieldView value={questionario.data_inicio_em} def={formDefFazendaCorte.data_inicio_em}/>

      <FieldView value={questionario.femeas_submetidas_iatf}
                 def={formDefFazendaCorte.femeas_submetidas_iatf}/>
      <FieldView value={questionario.bezerros_nascidos}
                 def={formDefFazendaCorte.bezerros_nascidos}/>
      <FieldView value={questionario.bezerros_desmamados}
                 def={formDefFazendaCorte.bezerros_desmamados}/>
    </>
  );
}

export default QuestionarioCorteV1;
